import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type TopicState = string[];

export const TOPIC = (
  Details: React.ComponentType<RuleTypeDetailsProps<TopicState>>,
): ConditionType<TopicState, ModelCondition.Topic> => ({
  name: "Message topic",
  description() {
    return "What is the topic of the customer message";
  },
  Details(props: RuleTypeDetailsProps<TopicState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.topics;
  },
  toModel(state) {
    return { type: ModelCondition.TOPIC, topics: state };
  },
  valid() {
    return true;
  },
});
